import BoxDownload from "./SubDownloadApp/BoxDownload";

function DownloadApp() {
    return (
        <>
            <div id="downloadApp"></div>
            <div className="flex py-12 
                            2xl:px-60
                            xl:px-40
                            lg:px-10
                            md:px-8 md:flex-row-reverse md:justify-between
                            md:px-7 
                            flex-col items-center justify-center
                            " >
                <img src="/image/DownloadApp.png"
                    className=" 
                                 sm:w-4/12 sm:h-1/6
                                 w-6/12 md:h-1/6
                                                    " />
                <div className="flex flex-col   
                                2xl:mt-20 2xl:mr-40
                                xl:mt-10 xl:mr-20
                                lg:mr-10 lg:w-7/12 
                                md:items-end
                                sm:w-10/12
                                items-center w-9/12
                                ">
                    <h1 className="t-purpleDark
                                    lg:mb-10 
                                    md:mb-5
                                    sm:text-2xl sm:fontTitr
                                    text-lg
                                    my-4 
                                    ">دانلود پیام رسان بوستان</h1>
                    <p className="text-gray-500
                                 lg:mb-10 lg:text-base
                                 md:mb-5 md:text-sm md:text-right
                                 mb-4 text-xs text-center
                                 ">برای دانلود پیام رسان بوستان به روی یکی از لینک های مورد نظر کلیک نمایید</p>
                    <div className="flex flex-row-reverse items-center justify-center flex-wrap">
                        <BoxDownload image="/image/icon/Download.png" text="دانلود مستقیم" link="https://api.bustan-messenger.ir/android/Bustan-Messenger.apk" />
                        <BoxDownload image="/image/icon/googlePlay.png" text="دانلود از گوگل پلی" />
                        <BoxDownload image="/image/icon/bazar.png" text="دانلود از بازار" link="https://cafebazaar.ir/app/com.bustan.messenger" />
                        <BoxDownload image="/image/icon/scan.png" text="دانلود بوسیله اسکن" />
                    </div>
                </div>
            </div>
        </>
    )
}
export default DownloadApp;